// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 1160px;
  padding: 0 10px;
  width: 100%;
  margin: 0 auto !important;
}

.ant-layout-content {
  padding-top: 100px !important;
}

.header {
  position: fixed;
  z-index: 6;
  width: 100%;
  background-color: #fbfbfb;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(20px);
}
.header_logo img {
  width: 100%;
}
.header_logo .logo {
  display: flex;
  align-items: center;
}
.header_logo svg {
  max-width: 190px;
}
.header_nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid transparent;
  margin-top: 15px;
}
.header_nav a {
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #aeaeae;
  padding-bottom: 5px;
  transition: 0.2s all ease-in-out;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 1100px) {
  .header_nav a {
    font-size: 16px;
  }
}
.header_nav a svg:not(.faq) {
  fill: #bebebe;
}
.header_nav a svg {
  margin-right: 8px;
  color: #bebebe;
  font-size: 18px;
}
@media screen and (max-width: 1000px) {
  .header_nav a svg {
    opacity: 0;
  }
}
.header_nav a:hover, .header_nav a.active {
  color: #00955f !important;
  transition: 0.2s all ease-in-out;
  font-weight: 500;
}
.header_nav a:hover svg:not(.faq), .header_nav a.active svg:not(.faq) {
  color: #00955f;
  fill: #00955f;
  font-size: 18px;
}
.header_nav a:hover svg.faq circle,
.header_nav a:hover svg.faq path, .header_nav a.active svg.faq circle,
.header_nav a.active svg.faq path {
  color: #00955f;
}
.header_right {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.header_right_rate {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 80px;
  margin-right: 24px;
}
.header_right_rate_top {
  display: flex;
  align-items: center;
}
.header_right_rate_bottom {
  display: flex;
  margin-top: 5px;
}
.header_right_rate_bottom b {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: #aeaeae;
  display: inline-block;
}
.header_right_rate_bottom b .anticon-question-circle {
  color: #00955f;
  margin-left: 5px;
  margin-top: 2px;
  line-height: 12px;
}
.header_right .rate_line {
  width: 68px;
  height: 14px;
  background-color: #00955f;
  border-radius: 2px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}
.header_right .rate_line_percent {
  position: absolute;
  width: 70%;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #00955f;
  z-index: 1;
}
.header_right .rate_line b {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  display: inherit;
  text-align: center;
  z-index: 2;
  position: relative;
}
.header_right .ant-dropdown-link {
  font-size: 20px;
  color: black;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  margin-left: 10px;
}
@media screen and (max-width: 1100px) {
  .header_right .ant-dropdown-link {
    margin-left: 3px;
  }
}
.header_right .ant-dropdown-link ul {
  font-size: 10px;
  margin: 0 auto;
  line-height: 1;
  display: inline;
  max-width: 100px;
}
.header_right .ant-dropdown-link span {
  display: block;
  width: 100%;
  line-height: 1;
}
.header_right .ant-dropdown-link span.email {
  font-size: 12px;
}
.header_user_info {
  width: 50px;
  height: 50px;
  background-color: #00955f;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #ffffff;
  margin-left: 5px;
}
@media screen and (max-width: 1100px) {
  .header_user_info {
    width: 40px;
    height: 40px;
  }
}
.header .container {
  flex-wrap: nowrap;
  height: 100%;
}
.header.header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer {
  background: #eee;
  padding: 32px 20px;
  margin-top: 50px;
}
.footer_links {
  justify-content: center;
  display: flex;
}
@media screen and (max-width: 1100px) {
  .footer_links {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
}
.footer_links a {
  margin: 0 15px;
  font-size: 18px;
  color: #00955f;
  line-height: 21px;
  display: inline-block;
  text-align: center;
}
@media screen and (max-width: 1100px) {
  .footer_links a {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 1100px) {
  .footer_social {
    text-align: center;
  }
}
.footer_social a {
  margin-right: 13px;
  opacity: 1;
  transition: 0.3s opacity ease-out;
}
.footer_social a:hover {
  opacity: 0.3;
  transition: 0.3s opacity ease-out;
}

.ant-layout {
  background-color: #fbfbfb;
}

.wrapper_for_blocks {
  background: #ffffff;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  border-radius: 20px;
  padding: 24px 32px;
  height: 100%;
}
@media screen and (min-width: 320px) {
  .wrapper_for_blocks {
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 768px) {
  .wrapper_for_blocks {
    margin-bottom: 20px;
    height: auto;
  }
}
@media screen and (max-width: 1000px) {
  .wrapper_for_blocks {
    padding: 30px 20px;
  }
}

.dropdown_menu {
  padding: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  text-align: left !important;
  max-width: 250px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  border-radius: 2px;
}
.dropdown_menu_self {
  display: flex;
  flex-direction: column;
  margin-bottom: 22px;
  margin-bottom: 10px;
}
.dropdown_menu_self small {
  position: relative;
}
.dropdown_menu_self small.shadow:after {
  content: "";
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 70%;
  height: 1.2em;
  background: linear-gradient(to right, rgba(63, 62, 62, 0), white 100%);
  pointer-events: none;
}
.dropdown_menu_self b,
.dropdown_menu_self .ant-typography,
.dropdown_menu_self small {
  font-size: 14px;
  color: #c2c2c2;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  font-weight: 400;
}
.dropdown_menu_self b span,
.dropdown_menu_self .ant-typography span,
.dropdown_menu_self small span {
  width: 50px;
  display: block;
}
.dropdown_menu_self .ant-typography,
.dropdown_menu_self small {
  margin-bottom: 0;
}
.dropdown_menu_self .anticon {
  width: auto !important;
  width: initial !important;
}
.dropdown_menu_self svg {
  color: #c2c2c2;
}
.dropdown_menu button:hover {
  color: rgb(196, 9, 9);
  transition: 0.2s color ease-in;
}
.dropdown_menu a {
  font-size: 14px;
  line-height: 16px;
  color: #aeaeae;
  padding: 15px 0 15px;
  border-bottom: 1px solid #e4e4e4;
  text-align: left !important;
  transition: 0.2s color ease-in;
}
.dropdown_menu a:hover {
  color: #00955f;
  transition: 0.2s color ease-in;
}
.dropdown_menu a.active {
  color: #00955f;
}
.dropdown_menu button {
  font-size: 14px;
  line-height: 16px;
  color: #aeaeae;
  text-align: left;
  margin-top: 10px;
  padding-left: 0;
  margin-left: 0;
}

.burger_menu {
  width: 0;
  transition: 0.1s all ease-in-out;
  overflow-y: hidden;
  height: 0;
}
.burger_menu_footer {
  position: absolute;
  visibility: hidden;
}
.burger_menu.visible {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  box-shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);
  transition: 0.1s all ease-in-out;
  z-index: 20;
  background-color: #ffffff;
  padding: 20px 10px;
  height: 100%;
}
.burger_menu.visible .burger_menu_footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  visibility: visible;
}
.burger_menu_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.burger_menu_top svg {
  max-width: 190px;
  max-height: 58px;
}
.burger_menu_top h1 {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 0;
  opacity: 0.8;
}
.burger_menu_nav {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.burger_menu_nav .lang {
  margin-left: 20px;
}
.burger_menu_nav a {
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #6b6b6b;
  padding-bottom: 5px;
  transition: 0.2s all ease-in-out;
  border-bottom: 3px solid transparent;
  margin-bottom: 15px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.burger_menu_nav a span {
  margin-right: 10px;
  font-size: 20px;
}
.burger_menu_nav a.active {
  color: #00955f !important;
  transition: 0.2s all ease-in-out;
}
.burger_menu_nav a svg {
  opacity: 0;
  width: 18px;
  display: inline-block;
}

.lang {
  max-width: 50px;
  width: auto;
  position: relative;
  cursor: pointer;
  display: block;
}
.lang:hover .lang_list {
  top: 25px;
  opacity: 1;
  visibility: visible;
  transition: 0.4s all ease-in;
  line-height: 1;
}
.lang img {
  width: 25px;
  height: 25px;
  margin-right: 5px;
  margin-top: 0;
}
.lang b {
  font-size: 18px;
  color: rgb(255, 255, 255);
  line-height: 1;
  margin: 0;
}
.lang_active {
  display: flex;
  align-items: center;
}
.lang_list {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
}
.lang_list_item {
  padding-top: 5px;
}

.alerts_block {
  width: 70%;
  margin-bottom: 15px;
  display: block;
}
@media screen and (max-width: 1000px) {
  .alerts_block {
    width: 100%;
  }
}

.header_wrap_logo {
  display: inline-flex;
  position: relative;
}
.header_wrap_logo .beta {
  position: absolute;
  top: -8px;
  right: 0;
  font-size: 14px;
  color: #ffffff;
  background-color: #13c2c2;
  height: 18px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px 0 6px 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/layouts.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAOA;EACI,iBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,6BAAA;AAFJ;;AAKA;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,yBCrBS;EDsBT,YAAA;EACA,0CAAA;EACA,mCAAA;EACA,2BAAA;AAFJ;AAKQ;EACI,WAAA;AAHZ;AAMQ;EACI,aAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,gBAAA;AALZ;AASI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;AAPR;AASQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;AAPZ;AASY;EAVJ;IAWQ,eAAA;EANd;AACF;AAQY;EACI,aAAA;AANhB;AASY;EACI,iBAAA;EACA,cAAA;EAEA,eAAA;AARhB;AAUgB;EANJ;IAOQ,UAAA;EAPlB;AACF;AAUY;EA7ER,yBAAA;EACA,gCAAA;EA+EY,gBAAA;AARhB;AASgB;EACI,cCjFR;EDkFQ,aClFR;EDmFQ,eAAA;AAPpB;AAWoB;;;EAEI,cCzFZ;ADiFZ;AAeI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAbR;AAeQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAbZ;AAeY;EACI,aAAA;EACA,mBAAA;AAbhB;AAiBY;EACI,aAAA;EACA,eAAA;AAfhB;AAiBgB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAfpB;AAiBoB;EACI,cC/HZ;EDgIY,gBAAA;EACA,eAAA;EACA,iBAAA;AAfxB;AAqBQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAnBZ;AAqBY;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AAnBhB;AAsBY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AApBhB;AAwBQ;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAtBZ;AAwBY;EARJ;IASQ,gBAAA;EArBd;AACF;AAuBY;EACI,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArBhB;AAwBY;EACI,cAAA;EACA,WAAA;EACA,cAAA;AAtBhB;AAwBgB;EACI,eAAA;AAtBpB;AA4BI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA1BR;AA4BQ;EAdJ;IAeQ,WAAA;IACA,YAAA;EAzBV;AACF;AA4BI;EACI,iBAAA;EACA,YAAA;AA1BR;AA6BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA3BR;;AA+BA;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;AA5BJ;AA8BI;EACI,uBAAA;EACA,aAAA;AA5BR;AA8BQ;EAJJ;IAKQ,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;EA3BV;AACF;AA6BQ;EACI,cAAA;EACA,eAAA;EACA,cCtOE;EDuOF,iBAAA;EACA,qBAAA;EACA,kBAAA;AA3BZ;AA8BY;EATJ;IAUQ,eAAA;IACA,mBAAA;EA3Bd;AACF;AAgCQ;EADJ;IAEQ,kBAAA;EA7BV;AACF;AA+BQ;EACI,kBAAA;EACA,UAAA;EACA,iCAAA;AA7BZ;AA+BY;EACI,YAAA;EACA,iCAAA;AA7BhB;;AAkCA;EACI,yBC7RS;AD8Pb;;AAiCA;EACI,mBAAA;EACA,wDC5RK;ED6RL,mBAAA;EACA,kBAAA;EACA,YAAA;AA9BJ;AAgCI;EAPJ;IAQQ,mBAAA;EA7BN;AACF;AA+BI;EAXJ;IAYQ,mBAAA;IACA,YAAA;EA5BN;AACF;AA8BI;EAhBJ;IAiBQ,kBAAA;EA3BN;AACF;;AA8BA;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,wDCxTK;EDyTL,kBAAA;AA3BJ;AA6BI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EAiDA,mBAAA;AA3ER;AA4BQ;EACI,kBAAA;AA1BZ;AA4BgB;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,sEAAA;EACA,oBAAA;AA1BpB;AA+BQ;;;EAGI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA7BZ;AA+BY;;;EACI,WAAA;EACA,cAAA;AA3BhB;AA+BQ;;EAEI,gBAAA;AA7BZ;AAgCQ;EACI,sBAAA;EAAA,yBAAA;AA9BZ;AAiCQ;EACI,cAAA;AA/BZ;AAsCQ;EACI,qBAAA;EACA,8BAAA;AApCZ;AAwCI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,2BAAA;EACA,8BAAA;AAtCR;AAwCQ;EACI,cCrYA;EDsYA,8BAAA;AAtCZ;AAyCQ;EACI,cC1YA;ADmWZ;AA0CI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAxCR;;AA4CA;EACI,QAAA;EACA,gCAAA;EACA,kBAAA;EACA,SAAA;AAzCJ;AA2CI;EACI,kBAAA;EACA,kBAAA;AAzCR;AA4CI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,wDCvaC;EDwaD,gCAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA1CR;AA4CQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;AA1CZ;AA8CI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA5CR;AA8CQ;EACI,gBAAA;EACA,gBAAA;AA5CZ;AA+CQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA7CZ;AAiDI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AA/CR;AAiDQ;EACI,iBAAA;AA/CZ;AAkDQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCxdM;EDydN,mBAAA;EACA,gCAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AAhDZ;AAkDY;EACI,kBAAA;EACA,eAAA;AAhDhB;AAmDY;EAteR,yBAAA;EACA,gCAAA;AAsbJ;AAmDY;EACI,UAAA;EACA,WAAA;EACA,qBAAA;AAjDhB;;AAuDA;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AApDJ;AAuDQ;EACI,SAAA;EACA,UAAA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;AArDZ;AAyDI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAvDR;AA0DI;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AAxDR;AA2DI;EACI,aAAA;EACA,mBAAA;AAzDR;AA4DI;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;AA1DR;AA4DQ;EACI,gBAAA;AA1DZ;;AA8DA;EACI,UAAA;EACA,mBAAA;EACA,cAAA;AA3DJ;AA6DI;EALJ;IAMQ,WAAA;EA1DN;AACF;;AA4DA;EACI,oBAAA;EACA,kBAAA;AAzDJ;AA2DI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAzDR","sourcesContent":["@import \"./variables.scss\";\n\n@mixin nav-hover {\n    color: $font-clor !important;\n    transition: 0.2s all ease-in-out;\n}\n\n.container {\n    max-width: 1160px;\n    padding: 0 10px;\n    width: 100%;\n    margin: 0 auto !important;\n}\n\n.ant-layout-content {\n    padding-top: 100px !important;\n}\n\n.header {\n    position: fixed;\n    z-index: 6;\n    width: 100%;\n    background-color: $background;\n    height: 80px;\n    background-color: rgba(255, 255, 255, 0.5);\n    -webkit-backdrop-filter: blur(40px);\n    backdrop-filter: blur(20px);\n\n    &_logo {\n        img {\n            width: 100%;\n        }\n\n        .logo {\n            display: flex;\n            align-items: center;\n        }\n\n        svg {\n            max-width: 190px;\n        }\n    }\n\n    &_nav {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-bottom: 1px solid transparent;\n        margin-top: 15px;\n\n        a {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 16px;\n            color: #aeaeae;\n            padding-bottom: 5px;\n            transition: 0.2s all ease-in-out;\n            display: flex;\n            align-items: center;\n\n            @media screen and (max-width: 1100px) {\n                font-size: 16px;\n            }\n\n            svg:not(.faq){\n                fill: #bebebe;\n            }\n\n            svg {\n                margin-right: 8px;\n                color: #bebebe;\n              \n                font-size: 18px;\n\n                @media screen and (max-width: 1000px) {\n                    opacity: 0;\n                }\n            }\n\n            &:hover,\n            &.active {\n                @include nav-hover;\n                font-weight: 500;\n                svg:not(.faq) {\n                    color: $font-clor;\n                    fill: $font-clor;\n                    font-size: 18px;\n                }\n\n                svg.faq{\n                    circle,\n                    path{\n                        color: $font-clor;\n                    } \n                }\n            }\n        }\n    }\n\n    &_right {\n        width: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n\n        &_rate {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            max-height: 80px;\n            margin-right: 24px;\n\n            &_top {\n                display: flex;\n                align-items: center;\n                // max-height: 50px;\n            }\n\n            &_bottom {\n                display: flex;\n                margin-top: 5px;\n\n                b {\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: 12px;\n                    color: #aeaeae;\n                    display: inline-block;\n\n                    .anticon-question-circle {\n                        color: $font-clor;\n                        margin-left: 5px;\n                        margin-top: 2px;\n                        line-height: 12px;\n                    }\n                }\n            }\n        }\n\n        .rate_line {\n            width: 68px;\n            height: 14px;\n            background-color: #00955f;\n            border-radius: 2px;\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 8px;\n\n            &_percent {\n                position: absolute;\n                width: 70%;\n                left: 0;\n                top: 0;\n                bottom: 0;\n                background-color: #00955f;\n                z-index: 1;\n            }\n\n            b {\n                color: #fff;\n                font-size: 12px;\n                font-weight: 400;\n                display: inherit;\n                text-align: center;\n                z-index: 2;\n                position: relative;\n            }\n        }\n\n        & .ant-dropdown-link {\n            font-size: 20px;\n            color: black;\n            display: flex;\n            flex-wrap: wrap;\n            text-align: center;\n            margin-left: 10px;\n\n            @media screen and (max-width: 1100px) {\n                margin-left: 3px;\n            }\n\n            ul {\n                font-size: 10px;\n                margin: 0 auto;\n                line-height: 1;\n                display: inline;\n                max-width: 100px;\n            }\n\n            & span {\n                display: block;\n                width: 100%;\n                line-height: 1;\n\n                &.email {\n                    font-size: 12px;\n                }\n            }\n        }\n    }\n\n    &_user_info {\n        width: 50px;\n        height: 50px;\n        background-color: #00955f;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 100px;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 21px;\n        color: #ffffff;\n        margin-left: 5px;\n\n        @media screen and (max-width: 1100px) {\n            width: 40px;\n            height: 40px;\n        }\n    }\n\n    .container {\n        flex-wrap: nowrap;\n        height: 100%;\n    }\n\n    &.header-mobile {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n}\n\n.footer {\n    background: #eee;\n    padding: 32px 20px;\n    margin-top: 50px;\n\n    &_links {\n        justify-content: center;\n        display: flex;\n\n        @media screen and (max-width: 1100px) {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            margin-bottom: 20px;\n        }\n\n        a {\n            margin: 0 15px;\n            font-size: 18px;\n            color: $default-btn;\n            line-height: 21px;\n            display: inline-block;\n            text-align: center;\n            // max-width: 190px;\n\n            @media screen and (max-width: 1100px) {\n                font-size: 16px;\n                margin-bottom: 10px;\n            }\n        }\n    }\n\n    &_social {\n        @media screen and (max-width: 1100px) {\n            text-align: center;\n        }\n\n        a {\n            margin-right: 13px;\n            opacity: 1;\n            transition: 0.3s opacity ease-out;\n\n            &:hover {\n                opacity: 0.3;\n                transition: 0.3s opacity ease-out;\n            }\n        }\n    }\n}\n.ant-layout {\n    background-color: $background;\n}\n.wrapper_for_blocks {\n    background: #ffffff;\n    box-shadow: $shadow;\n    border-radius: 20px;\n    padding: 24px 32px;\n    height: 100%;\n\n    @media screen and (min-width: $mobile) {\n        margin-bottom: 30px;\n    }\n\n    @media screen and (max-width: $tablet) {\n        margin-bottom: 20px;\n        height: auto;\n    }\n\n    @media screen and (max-width: $desktop) {\n        padding: 30px 20px;\n    }\n}\n\n.dropdown_menu {\n    padding: 20px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    text-align: left !important;\n    max-width: 250px;\n    width: 100%;\n    background: #ffffff;\n    box-shadow: $shadow;\n    border-radius: 2px;\n\n    &_self {\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 22px;\n\n        small {\n            position: relative;\n            &.shadow {\n                &:after {\n                    content: \"\";\n                    text-align: right;\n                    position: absolute;\n                    bottom: 0;\n                    right: 0;\n                    width: 70%;\n                    height: 1.2em;\n                    background: linear-gradient(to right, rgba(63, 62, 62, 0), white 100%);\n                    pointer-events: none;\n                }\n            }\n        }\n\n        b,\n        .ant-typography,\n        small {\n            font-size: 14px;\n            color: #c2c2c2;\n            margin-bottom: 2px;\n            display: flex;\n            align-items: center;\n            text-overflow: ellipsis;\n            font-weight: 400;\n\n            span {\n                width: 50px;\n                display: block;\n            }\n        }\n\n        .ant-typography,\n        small {\n            margin-bottom: 0;\n        }\n\n        .anticon {\n            width: unset !important;\n        }\n\n        svg {\n            color: #c2c2c2;\n        }\n\n        margin-bottom: 10px;\n    }\n\n    button {\n        &:hover {\n            color: rgb(196, 9, 9);\n            transition: 0.2s color ease-in;\n        }\n    }\n\n    a {\n        font-size: 14px;\n        line-height: 16px;\n        color: #aeaeae;\n        padding: 15px 0 15px;\n        border-bottom: 1px solid #e4e4e4;\n        text-align: left !important;\n        transition: 0.2s color ease-in;\n\n        &:hover {\n            color: $font-clor;\n            transition: 0.2s color ease-in;\n        }\n\n        &.active {\n            color: $font-clor;\n        }\n    }\n    button {\n        font-size: 14px;\n        line-height: 16px;\n        color: #aeaeae;\n        text-align: left;\n        margin-top: 10px;\n        padding-left: 0;\n        margin-left: 0;\n    }\n}\n\n.burger_menu {\n    width: 0;\n    transition: 0.1s all ease-in-out;\n    overflow-y: hidden;\n    height: 0;\n\n    &_footer {\n        position: absolute;\n        visibility: hidden;\n    }\n\n    &.visible {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        bottom: 0;\n        box-shadow: $shadow;\n        transition: 0.1s all ease-in-out;\n        z-index: 20;\n        background-color: #ffffff;\n        padding: 20px 10px;\n        height: 100%;\n\n        & .burger_menu_footer {\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            visibility: visible;\n        }\n    }\n\n    &_top {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        svg {\n            max-width: 190px;\n            max-height: 58px;\n        }\n\n        h1 {\n            font-size: 30px;\n            font-weight: 500;\n            margin-bottom: 0;\n            opacity: 0.8;\n        }\n    }\n\n    &_nav {\n        display: flex;\n        flex-direction: column;\n        margin-top: 25px;\n        width: fit-content;\n\n        .lang {\n            margin-left: 20px;\n        }\n\n        a {\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 23px;\n            color: $font-color-grey;\n            padding-bottom: 5px;\n            transition: 0.2s all ease-in-out;\n            border-bottom: 3px solid transparent;\n            margin-bottom: 15px;\n            width: fit-content;\n\n            span {\n                margin-right: 10px;\n                font-size: 20px;\n            }\n\n            &.active {\n                @include nav-hover;\n            }\n\n            svg {\n                opacity: 0;\n                width: 18px;\n                display: inline-block;\n            }\n        }\n    }\n}\n\n.lang {\n    max-width: 50px;\n    width: auto;\n    position: relative;\n    cursor: pointer;\n    display: block;\n\n    &:hover {\n        .lang_list {\n            top: 25px;\n            opacity: 1;\n            visibility: visible;\n            transition: 0.4s all ease-in;\n            line-height: 1;\n        }\n    }\n\n    img {\n        width: 25px;\n        height: 25px;\n        margin-right: 5px;\n        margin-top: 0;\n    }\n\n    b {\n        font-size: 18px;\n        color: rgb(255, 255, 255);\n        line-height: 1;\n        margin: 0;\n    }\n\n    &_active {\n        display: flex;\n        align-items: center;\n    }\n\n    &_list {\n        opacity: 0;\n        visibility: hidden;\n        position: absolute;\n        top: 0;\n\n        &_item {\n            padding-top: 5px;\n        }\n    }\n}\n.alerts_block {\n    width: 70%;\n    margin-bottom: 15px;\n    display: block;\n    \n    @media screen and (max-width: $desktop) {\n        width: 100%;\n    }\n}\n.header_wrap_logo{\n    display: inline-flex;\n    position: relative;\n\n    .beta{\n        position: absolute;\n        top: -8px;\n        right: 0;\n        font-size: 14px;\n        color: #ffffff;\n        background-color: #13c2c2;\n        height: 18px;\n        width: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 6px 0 6px 0;\n    }\n}","$main: rgba(1, 83, 34, 0.7);\n$background: #fbfbfb;\n$white-color: #ffffff;\n$header-background: white;\n$font-clor: #00955f;\n$font-color-grey: #6b6b6b;\n$shadow: 0px 10px 50px -15px rgba(132, 132, 132, 0.3);\n$border-radius-btn: 20px;\n$shadow-btn: 0px 10px 12px -6px #3d9877;\n\n$grey-background: #f1f1f1;\n$grey-color: #757575;\n$blue-background: #46a6ff;\n\n:export {\n    color: $main;\n}\n\n$width_auth_description_block: 275px;\n// $retina: \"(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)\";\n\n$mobile: 320px;\n$tablet: 768px;\n$desktop: 1000px;\n\n$default-btn: #00955f;\n$default-btn-hover: #0ab475;\n$danger-btn:  #9c0e0e;\n$danger-btn-hover: #ff0000;\n$primary-btn: #4285f4;\n$primary-btn-hover: #276ad9;\n\n@mixin default-button {\n    outline: none;\n    border: none;\n    transition: 0.3s all ease-in-out;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    box-shadow: $shadow-btn;\n    cursor: pointer;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    border-radius: 20px;\n    position: relative;\n}\n\n@mixin green-hover {\n    transition: 0.3s all ease-in-out;\n    background: $green-gradient-hover;\n    color: #ffffff;\n}\n\n@mixin green-focus {\n    @include green-hover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `rgba(1, 83, 34, 0.7)`
};
export default ___CSS_LOADER_EXPORT___;
